import React, { Fragment, useEffect, useState } from 'react';
import { FlexView, Row, COLORS } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { AppProvider } from '../../app-context';
import BookIcon from 'img/book.svg';
import MonitorIcon from 'img/monitor.svg';
import ClockIcon from 'img/clock.svg';
import GlobeIcon from 'img/globe.svg';
import { useStudentGet } from 'actions/studentsv2';
import BallLoader from 'comps/ball-loader';
import {
  Root,
  ChipLogo,
  ChipText,
  ChipView,
  ChipViewWrapper,
  HorizontalLine,
  POCHeading,
  POCValue,
  POCWrapper,
  StudentDetails,
  StudentDetailsWrapper,
  StudentIdHeading,
  VerticleLine,
  StudentDetailsRoutesWrapper,
  StudentNameHeading,
} from './styled-comps';
import { STUDENT_TYPE } from 'constants/student-profile';
import CopyButton from 'comps/copy-button';
import ActiveStatusIndicator from 'comps/student-statusI-indicator';
import { STUDENT_TAB_MENU } from 'comps/tab-menu/tabs';
import { parse } from 'query-string';
import styled from 'styled-components';
import { convertEpochToLocalTime } from 'utils';
import { trackEvent } from 'modules/analytics';
import { Drawer } from 'comps';
import { EVENT_TYPE } from 'constants/logger';

const POCValueWrapper = styled.div`
  max-width: 182px;
  overflow-wrap: break-word;
`;

const DivWrapper = styled.div`
  width: 100%;
  display: flex;
  font-family: 'Untitled Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  background: ${COLORS.ORANGE_XLIGHT};
  border-radius: 2px;
`;

const AccountTypeRow = styled(Row)`
  width: 100%;
  border: 1px solid ${COLORS.GRAY_LIGHT};
  border-radius: 2px;
`;

const POCValueDrawer = styled(POCValue)`
  :hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const CalenderText = styled(Text)`
  font-size: 12px;
`;

const StyledVerticleLine = styled.div`
  border-right: 1.5px solid #2b2b2bbf;
`;

const AllPocText = styled(Text)`
  color: rgba(43, 43, 43, 0.75);
  cursor: pointer
  text-decoration:underline;
  :hover{
    color:${COLORS.COLA};
  }
`;

const AllPocRow = styled(Row)`
  gap: 10px;
`;

const FlexViewWrapper = styled(Row)`
  width: 100%;
`;

const LoaderContainer = styled.div`
  width: 100%;
  height: calc(100vh - 58px);
  margin: auto;
  display: flex;
  align-items: center;
`;

const getClassCalender = slots => {
  if (!slots) return '';

  const arr = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

  return (
    <FlexViewWrapper justifyContent="space-evenly">
      {arr.map((item, i) => {
        const { schedule } = slots.find(({ schedule }) => schedule.includes(item)) || {};
        return (
          <Fragment key={item}>
            <CalenderText variant="eyebrow2" color={!schedule && '#2b2b2b4d'}>
              {schedule || item[0]}
            </CalenderText>
            {i < 6 && <VerticleLine />}
          </Fragment>
        );
      })}
    </FlexViewWrapper>
  );
};

const UserDetails = ({ userId }) => {
  const [sidePanelView, setSidePanelView] = useState({});
  const { id } = useParams();
  const { data: studentDetail, get: getStudent, isProcessing, isStale } = useStudentGet(
    id,
  );
  const history = useHistory();

  useEffect(() => {
    getStudent(id);
    trackEvent(EVENT_TYPE.STUDENT_INFO_SCREEN_VIEW, {
      student_id: id,
    });
  }, [getStudent, id, userId]);

  useEffect(() => {
    if (isStale && !isProcessing) {
      getStudent(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStale, id]);

  if (!studentDetail || isProcessing) {
    return (
      <LoaderContainer>
        <BallLoader />
      </LoaderContainer>
    );
  }

  const {
    ac_details: acDetails,
    country,
    derived_region_text: derivedRegionText,
    grade,
    is_demo: isDemo,
    name,
    parent_data: parentData,
    parent_name: parentName,
    parent_service_id: parentServiceId,
    primary_course: primaryCourse,
    primary_teacher_details: primaryTeacherDetails,
    slots,
    state,
    student_id: studentId,
    student_service_id: studentServiceId,
    student_type: studentType,
  } = studentDetail || {};
  const {
    rm_data: rmData,
    primary_user_id: parentPrimaryUserId,
    current_time: currentTime,
    time_zone_abbreviation: timeZoneAbbreviation,
    timezone,
  } = parentData || {};
  const formatedCurrentTime =
    currentTime && timezone && convertEpochToLocalTime(currentTime, timezone);
  const { class_ratio: classRatio, enrollment_type: enrollmentType } =
    primaryCourse || {};
  const { teacher_name: teacherName, teacher_id: teacherId } =
    primaryTeacherDetails || {};
  const { active_slots: activeSlots } = slots || {};
  const { first_name: rmFirstName, last_name: rmLastName, id: rmId } = rmData || {};
  
  const openPocs = () => {
    setSidePanelView({
      view: 'detailed-pocs',
      props: { primaryTeacherDetails, parentName, acDetails, rmData },
      title: 'More POCs',
    });

    trackEvent(EVENT_TYPE.MORE_POC_CLICK, {
      student_id: id,
    });
  };

  const openMoreIds = () => {
    setSidePanelView({
      view: 'more-ids',
      props: {
        primaryTeacherId: teacherId,
        studentId,
        parentId: parentPrimaryUserId,
        parentServiceId,
        studentServiceId,
      },
      title: 'More IDs',
    });

    trackEvent(EVENT_TYPE.MORE_IDS_CLICK, {
      parent_id: parentPrimaryUserId,
      parent_service_id: parentServiceId,
      student_id: id,
      student_service_id: studentServiceId,
      teacher_id: teacherId,
    });
  };

  const openParentInfo = () => {
    setSidePanelView({
      view: 'parent-info',
      props: { studentId, parentServiceId },
      title: 'Parent Info',
    });

    trackEvent(EVENT_TYPE.PARENT_NAME_CLICK, {
      student_id: id,
    });
  };

  const openTeachersInfo = () => {
    if (teacherId) {
      window.open(`/users/teachers/${teacherId}`, '_blank');

      trackEvent(EVENT_TYPE.TEACHER_NAME_CLICK, {
        student_id: id,
        teacher_id: teacherId,
      });
    }
  };

  const openContactInfo = () => {
    window.open(`/student-pii/${id}`, '_blank');

    trackEvent(EVENT_TYPE.CONTACT_INFO_CLICK, {
      student_id: id,
    });
  };

  const openCSMDetails = () => {
    rmId && window.open(`/users/csm/${rmId}`, '_blank');
  }
  
  const {
    location: { search },
  } = history;

  const { student_tab: studentTab } = parse(search);
  const tab = studentTab
    ? STUDENT_TAB_MENU.find(({ path }) => path === studentTab)
    : STUDENT_TAB_MENU[0];
  const { Component } = tab || {};
  const enrollmentTypeText =
    enrollmentType && enrollmentType[0] + enrollmentType.substring(1).toLowerCase();
  const classRatioText = classRatio ? `1:${classRatio}` : '';
  const rmNameText = (rmFirstName || '') + ' ' + (rmLastName || '');
  const isTrainingAccount = studentType !== STUDENT_TYPE;
  const currentTimeText = formatedCurrentTime
    ? `${formatedCurrentTime}(${timeZoneAbbreviation})`
    : '-';

  return (
    <Root>
      <AppProvider state={{ setSidePanelView, sidePanelView }}>
        <Drawer />
        <StudentDetailsWrapper>
          {(isDemo || isTrainingAccount) && (
            <DivWrapper>
              <AccountTypeRow justifyContent="center" alignItems="center">
                {isDemo ? 'Test Account' : 'Training Account'}
              </AccountTypeRow>
            </DivWrapper>
          )}
          <StudentDetails>
            <Row justifyContent="space-between" alignItems="flex-start">
              <StudentNameHeading variant="h5">{name || '-'}</StudentNameHeading>
              <ActiveStatusIndicator status={state || '-'} />
            </Row>
            <ChipViewWrapper flexWrap="wrap">
              <ChipView alignItems="center" justifyContent="flex-start" marginRight="6px">
                <ChipLogo src={BookIcon} />
                <ChipText variant="body2">Grade {grade || '-'}</ChipText>
              </ChipView>
              <ChipView alignItems="center" justifyContent="flex-start">
                <ChipLogo src={MonitorIcon} />
                <ChipText variant="body2">
                  {enrollmentType ? enrollmentTypeText : '-'} | {classRatioText || '-'}
                </ChipText>
              </ChipView>
              <ChipView alignItems="center" justifyContent="flex-start" marginRight="6px">
                <ChipLogo src={GlobeIcon} />
                <ChipText variant="body2"> {derivedRegionText || '-'}</ChipText>
              </ChipView>
              <ChipView alignItems="center" justifyContent="flex-start">
                <ChipLogo src={ClockIcon} />
                <ChipText variant="body2">{currentTimeText}</ChipText>
              </ChipView>
              <ChipView alignItems="center" justifyContent="flex-start">
                {getClassCalender(activeSlots)}
              </ChipView>
            </ChipViewWrapper>
            <POCWrapper>
              <Row>
                <POCHeading variant="eyebrow2">Parent</POCHeading>
                <POCValueWrapper>
                  <POCValueDrawer variant="cta1" onClick={openParentInfo}>
                    {parentName || '-'}
                  </POCValueDrawer>
                </POCValueWrapper>
              </Row>
              <Row>
                <POCHeading variant="eyebrow2">Teacher</POCHeading>
                <POCValueWrapper>
                  <POCValueDrawer variant="cta1" onClick={openTeachersInfo}>
                    {teacherName || '-'}
                  </POCValueDrawer>
                </POCValueWrapper>
              </Row>
              <Row>
                <POCHeading variant="eyebrow2">CSM</POCHeading>
                <POCValueWrapper>
                  <POCValueDrawer variant="cta1" onClick={openCSMDetails}>
                    {rmNameText?.trim() || '-'}
                  </POCValueDrawer>
                </POCValueWrapper>
              </Row>
              <AllPocRow>
                <AllPocText variant="cta2" onClick={openPocs}>
                  More POCs
                </AllPocText>
                <StyledVerticleLine />
                <AllPocText variant="cta2" onClick={openContactInfo}>
                  Contact info
                </AllPocText>
              </AllPocRow>
            </POCWrapper>
            <HorizontalLine />
            <FlexView>
              <StudentIdHeading justifyContent="space-between">
                <Text variant="eyebrow2" color={COLORS.COLA_LIGHTER}>
                  Student ID
                </Text>
                <AllPocText variant="cta2" onClick={openMoreIds}>
                  More IDs
                </AllPocText>
              </StudentIdHeading>
              <CopyButton copyMessage="Copy Student ID" text={studentId} />
            </FlexView>
          </StudentDetails>
        </StudentDetailsWrapper>

        <StudentDetailsRoutesWrapper>
          {studentTab && (
            <Component
              studentDetail={studentDetail}
              userId={userId}
              studentId={studentId}
              openTeachersInfo={openTeachersInfo}
            />
          )}
        </StudentDetailsRoutesWrapper>
      </AppProvider>
    </Root>
  );
};

export default connect(({ auth: { userId } = {} }) => ({
  userId,
}))(UserDetails);
